import Vue from 'vue'
import {http} from "../../axios";
import parseDateForLocal from "../../helpers/parseDateForLocal";
// import formMixins from '../../mixins/formMixins'

const mutationsSubscribeNames = [
  'setInputValue',
  'setJobTypeValue',
  'setSalaryValue'
]

function getVacancyEndDate() {
  const d = new Date()
  d.setMonth(d.getMonth() + 1)

  return d
}

function getInitState() {
  return {
    muted: false,
    mutationsSubscribeNames,
    pendingLoad: false,
    inputs: {
      title: {
        value: null,
        required: true
      },
      description: {
        value: null
      },
      direction_id: {
        value: null,
        required: true
      },
      category_id: {
        value: null,
        required: true
      },
      count: {
        value: 1,
      },
      job_start_date: {
        value: null,
      },
      job_duration: {
        value: null,
      },
      relevant_until: {
        value: getVacancyEndDate(),
      }
    },
    jobTypes: {
      job_types: '[{}]'
    },
    salaryInputs: {
      salary_type: {
        value: null
      },
      currency_id: {
        value: null
      },
      salary_fix: {
        value: null
      },
      salary_from: {
        value: null
      },
      salary_to: {
        value: null
      },
      salary_comment: {
        value: null
      }
    }
  }
}

export default {
  namespaced: true,
  state: {
    jobDurationList: [],
    ...getInitState()
  },
  mutations: {
    setMuted(state, value) {
      state.muted = value
    },
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setPendingLoad(state, value) {
      state.pendingLoad = value
    },
    setJobDurationList(state, value) {
      state.jobDurationList = value
    },
    setInputValue(state, {key, value}) {
      if (!state.inputs.hasOwnProperty(key)) return
      state.inputs[key].value = value
    },
    setJobTypeValue(state, value) {
      state.jobTypes.job_types = value
    },
    setSalaryValue(state, {key, value}) {
      if (!state.salaryInputs.hasOwnProperty(key)) return
      state.salaryInputs[key].value = value
    },
    setInputError(state, {key, error}) {
      Vue.set(state.inputs[key], 'error', error)
    },
    resetErrors(state) {
      for (let key in state.inputs) {
        Vue.set(state.inputs[key], 'error', null)
      }
    }
  },
  actions: {
    moderateFieldsIsRequired({state, commit}, groupKey) {
      let val = true

      for (let key in state[groupKey]) {
        if (state[groupKey][key].required && !state[groupKey][key].value) {
          commit('setInputError', {key, error: 'This field is required'})
          val = false
        }
      }

      return val
    },
    resetErrors({commit}) {
      commit('resetErrors')
    },

    load({dispatch, commit}) {
      commit('setPendingLoad', true)

      Promise.all([
        dispatch('loadJobDurationListList'),
      ]).then(() => {
        dispatch('setValueFromLists')
      }).finally(() => {
        commit('setPendingLoad', false)
      })
    },
    setValueFromLists({state, commit}) {
      const keys = {
        'job_duration': 'jobDurationList'
      }

      for (let [key, listKey] of Object.entries(keys)) {
        if (!isNaN(state.inputs[key].value)) {
          let value = state[listKey].find(item => item.id === state.inputs[key].value)
          if(value) commit('setInputValue', {key, value})
        }
      }

      commit('setMuted', false)
    },
    loadJobDurationListList({commit}) {
      return http.get('/api/helper/selectbox/job_duration').then(({data}) => {
        commit('setJobDurationList', data.data)
      })
    },
    setVacancyValues({state, commit, dispatch, rootState}, vacancy) {
      for (let key in state.inputs) {
        commit('setInputValue', {key, value: vacancy[key]})
      }

      commit('setJobTypeValue', vacancy.job_types)

      if (Array.isArray(state.inputs.job_start_date.value)) {
        let value = state.inputs.job_start_date.value.map(date => parseDateForLocal(date))
        commit('setInputValue', {key: 'job_start_date', value})
      }

      if (state.inputs.relevant_until.value) {
        let value = parseDateForLocal(state.inputs.relevant_until.value)
        commit('setInputValue', {key: 'relevant_until', value})
      }

      for (let key in state.salaryInputs) {
        commit('setSalaryValue', {key, value: vacancy[key]})
      }

      if (state.salaryInputs.salary_type.value) {
        let value = rootState.salaryTypes.find(item => item.id === state.salaryInputs.salary_type.value)
        commit('setSalaryValue', {key: 'salary_type', value})
      }

      if (state.salaryInputs.currency_id.value) {
        let value = rootState.currencies.find(item => item.id === state.salaryInputs.currency_id.value)
        commit('setSalaryValue', {key: 'currency_id', value})
      }

      dispatch('setValueFromLists')
    }
  }
}

//relevant_until: "2020-04-17T21:00:00.000Z"
//relevant_until: "2020-04-17 21:00:00"
